import { connect } from 'react-redux';

import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { getMeta, persisFilters, validateGeo } from '../../actions/filters';
import { FiltersSearchButtons, IFiltersSearchButtonsProps } from '../../components/FiltersSearchButtons';
import { selectIsSutochnoPilotEnabled, selectSutochnoRegionType } from '../../selectors/sutochnoPilot';
import { selectGeoSearch } from '../../selectors/filters/geoSearch';
import { selectDepartureDates } from '../../selectors/filters/departureDates';
import { generateSutochnoUrl } from '../../utils/sutochno';
import { selectGuests } from '../../selectors/filters/guests';
import { formatOfferCount } from './utils/formatOfferCount';
import { getIsNewbuildingOnboardingEnabled } from '../../selectors/newbuildingOnboarding/';
import { isNewbuildingOnboardingExperimentEnabled } from '../../utils/newbuildingOnboarding';
import { selectPageKind } from '../../selectors/pageKind';
import { isDefaultPage } from '../../utils/pageKind';
import { dealTypeFromJsonQuery, FDealType } from '../../utils/category';

type TFiltersStateProps = Pick<
  IFiltersSearchButtonsProps,
  | 'pageKind'
  | 'meta'
  | 'geocode'
  | 'isSutochnoFlow'
  | 'sutochnoUrl'
  | 'offerCount'
  | 'isGeoEmpty'
  | 'isSutochnoPilotEnabled'
  | 'isNewbuildingOnboardingButtonEnabled'
>;

type TFilterOfferTypeDispatchProps = Pick<IFiltersSearchButtonsProps, 'getMeta' | 'persistFilters' | 'validateGeo'>;

export function mapStateToProps(state: IApplicationState): TFiltersStateProps {
  const {
    filters: { meta },
  } = state;

  const pageKind = selectPageKind(state);
  const isSutochnoPilotEnabled = selectIsSutochnoPilotEnabled(state);
  const sutochnoRegionType = selectSutochnoRegionType(state);
  const geoSearch = selectGeoSearch(state);
  const departureDates = selectDepartureDates(state);
  const guests = selectGuests(state);

  const isSutochnoFlow = isSutochnoPilotEnabled && sutochnoRegionType === 'target';
  const sutochnoUrl = generateSutochnoUrl({ geoSearch, departureDates, guests });

  const offerCount = isSutochnoFlow ? undefined : formatOfferCount({ offerCount: meta.count });
  const isNewbuildingOnboardingButtonEnabled =
    isDefaultPage(pageKind) &&
    dealTypeFromJsonQuery(state.filters.jsonQuery) === FDealType.Sale &&
    getIsNewbuildingOnboardingEnabled(state) &&
    isNewbuildingOnboardingExperimentEnabled(state);

  return {
    pageKind,
    meta: state.filters.meta,
    geocode: state.filters.geocode,
    isSutochnoFlow,
    sutochnoUrl,
    offerCount,
    isGeoEmpty: !geoSearch,
    isSutochnoPilotEnabled,
    isNewbuildingOnboardingButtonEnabled,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterOfferTypeDispatchProps {
  return {
    getMeta: () => dispatch(getMeta()),
    persistFilters: () => dispatch(persisFilters()),
    validateGeo: (error: string | null) => dispatch(validateGeo(error)),
  };
}

export const FiltersSearchButtonsContainer = connect(mapStateToProps, mapDispatchToProps)(FiltersSearchButtons);
